(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/my-information-panel.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/my-information-panel.js');
'use strict';

const {
  getCustomerBankAccounts
} = svs.myProfile.react.store.pd.actions;
const {
  InfoPair,
  BankAccountCard
} = svs.myProfile.react.pages.myInformation.myInformation.components;
const {
  MobileCard
} = svs.myProfile.react.pages.myInformation.myInformation.mobile;
const {
  EmailCard
} = svs.myProfile.react.pages.myInformation.myInformation.email;
const {
  FULFILLED,
  REJECTED
} = svs.myProfile.constants.thunkStatus;
const {
  showTechnicalError
} = svs.myProfile.react.shared.dialogs;
const {
  Skeleton
} = svs.myProfile.react.shared.components;
const {
  toTitleCase
} = svs.myProfile.react.pages.myInformation.myInformationHelpers;
const {
  stringFormat
} = svs.components.tbUtils;

const MyInformationPanel = _ref => {
  let {
    isChangeEmail,
    isChangeMobile
  } = _ref;
  const dispatch = ReactRedux.useDispatch();
  const [name, setName] = React.useState('');
  const [address, setAddress] = React.useState('');
  const playerPreferences = ReactRedux.useSelector(state => state.playerPreferences.playerPreferences);
  const playerPreferencesStatus = ReactRedux.useSelector(state => state.playerPreferences.playerPreferencesStatus.status);
  const isPreferenceDataLoaded = ReactRedux.useSelector(state => state.playerPreferences.isPreferenceDataLoaded);
  React.useEffect(() => {
    dispatch(getCustomerBankAccounts());
  }, [dispatch]);
  React.useEffect(() => {
    if (playerPreferencesStatus === FULFILLED || playerPreferencesStatus === REJECTED) {
      if (!playerPreferences.cid) {
        showTechnicalError();
      }
    }
  }, [playerPreferences, playerPreferencesStatus]);
  React.useEffect(() => {
    if (playerPreferencesStatus === FULFILLED) {
      if (playerPreferences !== null && playerPreferences !== void 0 && playerPreferences.name) {
        setName(stringFormat.nameCase("".concat(playerPreferences === null || playerPreferences === void 0 ? void 0 : playerPreferences.name, " ").concat(playerPreferences === null || playerPreferences === void 0 ? void 0 : playerPreferences.surname)));
      } else {
        setName(React.createElement("i", null, "Dold"));
      }
      if (playerPreferences !== null && playerPreferences !== void 0 && playerPreferences.address) {
        setAddress(toTitleCase("".concat(playerPreferences === null || playerPreferences === void 0 ? void 0 : playerPreferences.address, " ").concat(playerPreferences === null || playerPreferences === void 0 ? void 0 : playerPreferences.location).toLowerCase()));
      }
    }
  }, [playerPreferences, playerPreferencesStatus]);
  return React.createElement("div", {
    className: "f-center"
  }, !isPreferenceDataLoaded && React.createElement(React.Fragment, null, React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 1,
    boxWidthProcent: 70,
    topMargin: 0
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 1,
    boxWidthProcent: 70,
    topMargin: 1
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 1,
    boxWidthProcent: 70,
    topMargin: 1
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 6,
    boxWidthProcent: 100,
    topMargin: 4
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 6,
    boxWidthProcent: 100,
    topMargin: 1
  }), React.createElement(Skeleton, {
    bottomMargin: 4,
    boxHeight: 6,
    boxWidthProcent: 100,
    topMargin: 1
  })), isPreferenceDataLoaded && React.createElement(React.Fragment, null, React.createElement(InfoPair, {
    info: name,
    title: "Namn"
  }), React.createElement(InfoPair, {
    info: playerPreferences === null || playerPreferences === void 0 ? void 0 : playerPreferences.cid,
    title: "Kundnummer"
  }), React.createElement(InfoPair, {
    info: address,
    title: "Adress"
  }), React.createElement(EmailCard, {
    isFocused: isChangeEmail
  }), React.createElement(MobileCard, {
    isFocused: isChangeMobile
  }), React.createElement(BankAccountCard, null)));
};
svs.myProfile.react.pages.myInformation.myInformation.MyInformationPanel = MyInformationPanel;

 })(window);